import { Button, Flex, Space, Table, Tag, Typography } from "antd";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../../common/spinner/Spinner";
import { dateObjToDispViewDate } from "../../../../../../utils/utils";
import { colors } from "../../../../../../constants/colors";
import { useSelector } from "react-redux";
import { getSuperAdminSubscriptionAction } from "../../../../../../redux/services/super-admin-subscriptions/superAdminSubscriptions";
import styles from "./SubscriptionPlan.module.scss";
import { getSubscriptionPlansAction } from "../../../../../../redux/services/subscription-plan/subscriptionPlanServices";
import { DeleteIcon, EditIcon } from "../../../../../../assets/svg";

const SubscriptionPlan = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* For navigating between pages */
  const navigate = useNavigate();
  /* For navigating between pages */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* table dependencies */
  const [columns, setColumns] = useState([]);
  const { subscriptionPlans } = useSelector((state) => state.subscriptionPlans);
  /* table dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    const dataToBeSent = {};
    dispatch(getSubscriptionPlansAction(dataToBeSent, setLoading));
  };
  /* function definition to get table data */

  useEffect(() => {
    handleGetTableData();
  }, []);

  /* initial dependencies rendering */
  useEffect(() => {
    /* table column config */
    const tempTableColumns = [
      {
        title: t("activeSubs.subscriptionPlan"),
        dataIndex: "name",
        key: "name",
      },
      {
        title: t("Modules.AddLoginsAndSponsorships.logins"),
        dataIndex: "number_of_logins",
        key: "number_of_logins",
      },
      {
        title: t("createAt"),
        dataIndex: "created_at",
        key: "created_at",
        render: (_, record) => (
          <p>{dateObjToDispViewDate(record?.created_at, "ddmmyyyy")}</p>
        ),
      },
      {
        title: t("features"),
        key: "features",
        dataIndex: "features",
        render: (_, { features }) => (
          <div
            style={{
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "550px",
              overflow: "hidden",
            }}
          >
            {features?.join(", ") || "-"}
          </div>
        ),
      },
      {
        title: t("Modules.AutoCredit.status"),
        key: "action",
        align: "center",
        render: (_, record) => {
          return (
            <>
              <Tag
                bordered={false}
                style={{
                  background: record?.is_active
                    ? colors.lightTeal
                    : colors.lightPinkishRed,
                  color: record?.is_active
                    ? colors.darkTeal
                    : colors.darkMaroon,
                }}
              >
                {record?.is_active ? t("CommonUtils.active") : t("CommonUtils.inactive")}
              </Tag>
            </>
          );
        },
      },
    ];
    /* table column config */
    setColumns(tempTableColumns);
  }, []);
  /* initial dependencies rendering */

  return (
    <div className={styles.activeSubscriptionContainer}>
      <Flex vertical gap="2rem">
        <Flex align="center" justify="space-between">
          <Typography.Title level={2}>
            {t("activeSubs.subscriptionPlan")}
          </Typography.Title>
        </Flex>
        {loading ? (
          <Spinner />
        ) : (
          <Table
            dataSource={subscriptionPlans?.data}
            columns={columns}
            pagination
          />
        )}
      </Flex>
    </div>
  );
};

export default SubscriptionPlan;
